import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { X, MessageCircle, Calendar } from 'lucide-react';
import './CommitCtaModal.css';

const DEFAULT_TITLE = 'Ready to Start?';
const DEFAULT_SUBTITLE =
  "Take the first step towards your transformation. Fill out the form below or send us a message.";

function CommitCtaModal({ isOpen, onClose }) {
  const [contact, setContact] = useState({ title: DEFAULT_TITLE, subtitle: '' });

  useEffect(() => {
    if (!isOpen) return;
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'settings', 'contact'));
        if (!cancelled && snap.exists()) {
          const d = snap.data();
          setContact({
            title: d.title || DEFAULT_TITLE,
            subtitle: d.subtitle || '',
          });
        }
      } catch (e) {
        console.error('CommitCtaModal contact fetch:', e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const openContact = () => {
    onClose();
    window.dispatchEvent(new CustomEvent('bodyworks-open-contact'));
  };

  const openTraining = () => {
    onClose();
    window.dispatchEvent(new CustomEvent('bodyworks-open-training'));
  };

  const modal = (
    <div className="commit-cta-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="commit-cta-modal-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="commit-cta-title"
      >
        <button type="button" className="commit-cta-modal-close" onClick={onClose} aria-label="Close">
          <X size={22} />
        </button>
        <h2 id="commit-cta-title" className="commit-cta-modal-title">
          {contact.title}
        </h2>
        <p className="commit-cta-modal-subtitle">
          {contact.subtitle || DEFAULT_SUBTITLE}
        </p>
        <div className="contact-buttons">
          <button type="button" onClick={openContact} className="cta-button cta-button--static">
            <MessageCircle size={20} />
            <span>Send Message</span>
          </button>
          <button type="button" onClick={openTraining} className="cta-button-secondary">
            <Calendar size={20} />
            <span>Book Appointment</span>
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}

export default CommitCtaModal;
